import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function CriticalRiskIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 50, 50);
  const a11y = resolveA11yProps(props);

  return (
    <svg
      {...a11y}
      {...rest}
      width={width}
      height={height}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.0319 5.05859C26.3898 5.05859 27.4906 6.15435 27.4906 7.50604C27.4906 8.54652 26.8379 9.43417 25.9182 9.7883L26.3055 11.6159C34.7176 12.4437 39.3807 16.909 43.9307 23.2439C44.4985 24.0344 44.8634 24.9738 44.9529 25.9914C45.0157 26.7052 45.0157 27.466 44.9529 28.1797C44.8634 29.1973 44.4985 30.1364 43.9307 30.9268C38.3872 38.6439 32.2059 40.6809 23.6856 44.8842C23.314 45.0675 22.8692 44.802 22.8692 44.3892L24.5311 40.9544C15.8441 40.9544 10.8077 37.4358 6.13295 30.9268C4.62698 28.8298 4.61771 25.3541 6.133 23.2439C10.683 16.9077 15.3446 12.4445 23.7578 11.6159L24.1446 9.7883C23.2254 9.43393 22.5733 8.54617 22.5733 7.50604C22.5733 6.15435 23.6741 5.05859 25.0319 5.05859Z"
        fill="white"
      />
      <path
        d="M21.7032 30.5996C23.68 29.1351 26.3221 29.1355 28.2989 30.5996C28.5198 30.7642 28.5665 31.0773 28.4024 31.2988C28.2381 31.5199 27.9248 31.5659 27.7032 31.4023C26.0801 30.2004 23.9219 30.2002 22.2989 31.4023C22.0774 31.5664 21.7643 31.5197 21.5997 31.2988C21.4354 31.0771 21.4816 30.7641 21.7032 30.5996Z"
        fill="#D15B46"
      />
      <path
        d="M20.9571 22.374C21.8622 22.3741 22.5957 23.1854 22.5958 24.1865V26C22.5956 27.0011 21.8622 27.8125 20.9571 27.8125C20.052 27.8125 19.3186 27.0011 19.3184 26V24.1865C19.3185 23.1854 20.0519 22.374 20.9571 22.374Z"
        fill="#D15B46"
      />
      <path
        d="M29.1065 22.374C30.0117 22.374 30.7461 23.1854 30.7462 24.1865V26C30.746 27.0011 30.0116 27.8125 29.1065 27.8125C28.2016 27.8122 27.468 27.0009 27.4678 26V24.1865C27.4679 23.1855 28.2015 22.3743 29.1065 22.374Z"
        fill="#D15B46"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.0323 5C26.39 5.00016 27.4902 6.09576 27.4903 7.44727C27.4903 8.48775 26.8377 9.37537 25.918 9.72949L26.3057 11.5576C34.7177 12.3854 39.3807 16.8507 43.9307 23.1855C44.4984 23.976 44.8636 24.9151 44.9532 25.9326C45.016 26.6463 45.016 27.4074 44.9532 28.1211C44.8637 29.1387 44.4985 30.0778 43.9307 30.8682C38.3872 38.5852 32.2058 40.622 23.6856 44.8252C23.3142 45.0084 22.8695 44.7436 22.8692 44.3311L24.5313 40.8955C15.8443 40.8955 10.8076 37.3772 6.13287 30.8682C4.627 28.7713 4.61776 25.2957 6.13287 23.1855C10.6829 16.8494 15.3447 12.3862 23.7579 11.5576L24.1446 9.72949C23.2255 9.37509 22.5733 8.48734 22.5733 7.44727C22.5734 6.09566 23.6745 5 25.0323 5ZM38.3477 29.4512C40.5814 12.5587 9.57724 13.2766 11.7159 29.4512C12.2 33.1119 15.0941 34.3315 18.7715 34.8135C22.7196 35.3309 27.3158 35.3346 31.2921 34.8135C34.9696 34.3315 37.8635 33.112 38.3477 29.4512Z"
        fill="#D15B46"
      />
    </svg>
  );
}

export default CriticalRiskIcon;
